import { Component, ViewChild } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../globals";
import { InvoicesServices } from "../services";
import { InvoicesViewPage } from "../invoices-view/invoices-view";
import { TranslateService } from '@ngx-translate/core';
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';

/**
 * Generated class for the InvoicesListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-invoices-list',
  templateUrl: 'invoices-list.html',
})
export class InvoicesListPage {

  //datatable
  sorts = [
    { prop: 'customer', dir: 'asc' },
    { prop: 'invoice_number', dir: 'asc' },
    { prop: 'total', dir: 'asc' },
    { prop: 'payed', dir: 'asc' }
  ];
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;
  config_msg = {
    emptyMessage: this.translate.instant('general-no-hay-datos'),
    totalMessage: this.translate.instant('general-total'),
    selectedMessage: this.translate.instant('general-seleccionado')
  };

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public invoicesServices: InvoicesServices,
    public translate: TranslateService) {
    this.globals.GAtrackView('Income/Expenses', 'Income/Expenses - Invoices - List', this.globals.restaurant.email, 'View', 'List invoices', 'Income/Expenses', '');
    this.invoicesServices.invoices_searchbar_text = '';
    this.invoicesServices.invoices_array_filtered = this.invoicesServices.invoices_array_tmp;
  }

  ionViewWillEnter() {
    if (!this.globals.checkLimitsByLicense('sales', 'invoices')) {
      this.navCtrl.pop();
      this.navCtrl.push(AddonsTriggerVersionProPage);
    } else {
      let loadingPopup = this.loadingCtrl.create({
        spinner: 'crescent',
        content: this.translate.instant('instant-cargando-facturas')
      });
      loadingPopup.present();
      this.invoicesServices.getNodeInvoices();
      loadingPopup.dismiss();
    }

  }

  openInvoice(invoice) {
    this.navCtrl.push(InvoicesViewPage, {
      'type': 'pay',
      'invoice': invoice,
    });
  }

  clickElement(event) {
    if (event.type == 'click') {
      this.navCtrl.push(InvoicesViewPage, {
        'type': 'pay',
        'invoice': event.row,
      });
    }
  }

  onSort(event) {
    var invoices_array = this.invoicesServices.invoices_array_filtered;

    switch (event.column.name) {
      case 'customer':
        if (event.newValue == 'asc') {
          invoices_array.sort((a, b) => a.customer.localeCompare(b.customer));
        } else {
          invoices_array.sort((a, b) => b.customer.localeCompare(a.customer));
        }
        break;
      case 'invoice_number':
        if (event.newValue == 'asc') {
          invoices_array.sort((a, b) => a.invoice_number - b.invoice_number);
        } else {
          invoices_array.sort((a, b) => b.invoice_number - a.invoice_number);
        }
        break;
      case 'total':
        if (event.newValue == 'asc') {
          invoices_array.sort((a, b) => a.total - b.total);
        } else {
          invoices_array.sort((a, b) => b.total - a.total);
        }
        break;
      case 'payed':
        if (event.newValue == 'asc') {
          invoices_array.sort((a, b) => a.payed - b.payed);
        } else {
          invoices_array.sort((a, b) => b.payed - a.payed);
        }
        break;
    }

    this.invoicesServices.invoices_array_filtered = invoices_array;
  }

}



// WEBPACK FOOTER //
// ./src/pages/invoices/invoices-list/invoices-list.ts